import { memo, useCallback, useMemo } from "react";
import type { CameraUser, SiteUser } from "@src/features/settings/data/mock-sites";
import { ListRoleSelector } from "./ListRoleSelector";
import { router } from "expo-router";

type SpecificCameraAccessListProps = {
  users: SiteUser[];
  onRoleChange: (userId: string, role: SiteUser["role"]) => void;
  onPressItem: (userId: string) => void;
};

export const SpecificCameraAccessList = memo(({ users, onRoleChange, onPressItem }: SpecificCameraAccessListProps) => {
  const items = useMemo(
    () =>
      users.map((user) => ({
        id: user.id,
        name: user.name,
        role: user.role,
        email: user?.email,
        phoneNumber: user?.phoneNumber,
      })),
    [users],
  );

  const handleRoleChange = useCallback(
    (userId: string, role: SiteUser["role"]) => {
      onRoleChange(userId, role);
    },
    [onRoleChange],
  );

  return (
    <ListRoleSelector items={items} onRoleChange={handleRoleChange} iconName="chevronRight" onPressItem={onPressItem} />
  );
});
